import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { ISaveBankInformationRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createSaveBankInformationThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.SaveBankInformation,
    async (payload: { applicationId: string; bankInformation: ISaveBankInformationRequest }) => {
      const response = await api.saveBankInformation(
        payload.applicationId,
        payload.bankInformation,
      );

      return response;
    },
  );
